import { List, Map } from 'immutable'
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import ConsentList from './consentList'
import FilePreview from './preview'

function FileLink({ id, filename, url, isPublic, type, openPrivate, t }) {
  if (type === 'article') return null

  const props = {
    className: 'content-file-download tip tip--top',
    target: '_blank',
  }

  if (isPublic) {
    props.href = url
    props.download = filename
  } else {
    props.onClick = e => e.preventDefault() & openPrivate(id)
  }

  return (
    <a {...props} aria-label={t('common.download')}>
      <i className="fa fa-download" />
    </a>
  )
}

function FileGroup({ groups, type, openPrivate, addReviewId, content_id, t }) {
  let group = groups.get(type, List()).toJS()

  if (!group.length) return null

  return (
    <div className="content-file-group">
      <div className="content-file-group-title">{t(`content.group.${type}`)}</div>
      <div className="content-file-group-list">
        {group.map(file => {
          return (
            <div className="content-file" key={file.id}>
              <FilePreview {...file} content_id={content_id} addReviewId={addReviewId} type={type} t={t} />
              <FileLink {...file} type={type} openPrivate={openPrivate} t={t} />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default function ContentView(props) {
  let { match, content, t, token, organizationId } = props
  let { content_id } = match.params

  let item = content.find(c => c.get('id') === content_id)
  if (!item) return <div>Not found</div>

  let groups = item.get('materialGroups')

  let groupProps = {
    ...props,
    content_id,
    groups,
  }

  return (
    <Fragment>
      <div className="back-button">
        <Link className="back-button-item" to={`/yritys/${organizationId}`}>
          {t('back')}
        </Link>
      </div>
      <div className="content-groups">
        <FileGroup {...groupProps} type="video" />
        <FileGroup {...groupProps} type="image" />
        <FileGroup {...groupProps} type="article" />
        <FileGroup {...groupProps} type="other" />
      </div>
      <ConsentList interviewId={content_id} t={t} token={token} />
    </Fragment>
  )
}
